import React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const FilterElement = ({ item, onRemoveFilter }) => {
  return (
    <span className='badge-lg badge badge-primary mb-3 ml-2'>
      {`${item.label}: `}{item.title}
      <Link
        to="#"
        className="cursor-pointer ml-2 link-icon-color"
        id={`delete-icon-${item.identifier}`}
        onClick={e => {
          e.preventDefault();
          onRemoveFilter(item)
        }}
      >
         <FontAwesomeIcon
           size="lg"
           className="cursor-pointer"
           pointerEvents="none"
           icon={faTimes}
         />
      </Link>
    </span>
  );
}

export { FilterElement };

